import React, { useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

const RecipienDropdownList = ({
  item,
  setIsDropdownOpen,
  setFormItems,
  formItems,
  selectedRecipientPreviewName,
  setSelectedRecipientPreviewName,
}) => {
  const { getTextByKey } = useContent();
  const recipients = item.fields.recipients;
  const recipientType = item.fields.recipientType;

  const [selectedRecipients, setSelectedRecipients] = useState(
    item.fields?.dropdownSavedRecipients?.map((recipient) => {
      const fullRecipient = recipients.find((r) => r.id === recipient.id);
      return fullRecipient || recipient;
    }) || []
  );

  if (!recipients || recipients.length === 0) return null;

  const handleRecipientChange = (recipient, isChecked) => {
    if (recipientType === "multiple-choice") {
      const newSelectedRecipients = isChecked
        ? [...selectedRecipients, recipient]
        : selectedRecipients.filter((r) => r.id !== recipient.id);
      setSelectedRecipients(newSelectedRecipients);
    } else {
      const newSelectedRecipients = isChecked ? [recipient] : [];
      setSelectedRecipients(newSelectedRecipients);
      if (selectedRecipientPreviewName) {
        setSelectedRecipientPreviewName(
          newSelectedRecipients.map((r) => r.name).join(", ")
        );
      }
    }
  };

  const handleItemClick = (recipient, e) => {
    e.stopPropagation();
    const isCurrentlySelected = selectedRecipients.some(
      (r) => r.id === recipient.id
    );
    handleRecipientChange(recipient, !isCurrentlySelected);

    // Для single-choice сразу применяем изменения и закрываем дропдаун
    if (recipientType === "single-choice") {
      if (!formItems) {
        setIsDropdownOpen(false);
        return;
      }

      const updatedItem = {
        ...item,
        fields: {
          ...item.fields,
          dropdownSavedRecipients: !isCurrentlySelected ? [recipient] : [],
        },
      };
      const updatedItems = formItems.map((formItem) => {
        return formItem.id === item.id ? updatedItem : formItem;
      });
      setFormItems(updatedItems);
      setIsDropdownOpen(false);
    }
  };

  const handleClearAll = (e) => {
    e.stopPropagation();
    setSelectedRecipients([]);
    const updatedItem = {
      ...item,
      fields: {
        ...item.fields,
        dropdownSavedRecipients: [],
      },
    };

    if (!formItems) {
      if (selectedRecipientPreviewName) {
        setSelectedRecipientPreviewName("");
      }
      return;
    }

    const updatedItems = formItems.map((formItem) => {
      return formItem.id === item.id ? updatedItem : formItem;
    });
    setFormItems(updatedItems);

    if (selectedRecipientPreviewName) {
      setSelectedRecipientPreviewName("");
    }
  };

  const handleApply = () => {
    const updatedItem = {
      ...item,
      fields: {
        ...item.fields,
        dropdownSavedRecipients: selectedRecipients,
      },
    };
    console.log("!!!", selectedRecipients);

    setSelectedRecipientPreviewName(
      selectedRecipients.map((r) => r.name).join(", ")
    );

    if (!formItems) {
      setIsDropdownOpen(false);
      return;
    }

    const updatedItems = formItems.map((formItem) => {
      return formItem.id === item.id ? updatedItem : formItem;
    });

    setFormItems(updatedItems);
    setIsDropdownOpen(false);
  };

  return (
    <div className="recipient-dropdown-content-wrapper">
      <div className={`recipient-dropdown-content `}>
        <ul className="recipient-dropdown-list">
          {recipients.map((recipient) => {
            const isSelected = selectedRecipients.some(
              (r) => r.id === recipient.id
            );
            return (
              <li
                key={recipient.id}
                className={`recipient-dropdown-item ${
                  recipientType === "single-choice"
                    ? "single-dropdown-item"
                    : ""
                } ${isSelected ? "selected-dropdown-item" : ""}`}
                onClick={(e) => handleItemClick(recipient, e)}
              >
                {recipientType === "multiple-choice" ? (
                  <>
                    <div
                      className={`custom-checkbox ${
                        isSelected ? "selected" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        id={recipient.id}
                        checked={isSelected}
                      />
                      {isSelected && (
                        <Icon name="newInbox/mark" iconClass="mark-icon" blue />
                      )}
                    </div>
                    <label
                      htmlFor={recipient.id}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        width: "80%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                    >
                      {recipient.name}
                    </label>
                  </>
                ) : (
                  <label
                    htmlFor={recipient.id}
                    style={{
                      width: "80%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    {recipient.name}
                  </label>
                )}
              </li>
            );
          })}
        </ul>
        {recipientType === "multiple-choice" && (
          <div className="recipient-list-button-wrapper">
            <Button onClick={handleApply}>
              {getTextByKey("filter-apply")}
            </Button>
            <button className="clear-button" onClick={(e) => handleClearAll(e)}>
              {getTextByKey("filter-clear-all")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipienDropdownList;
